import request from './request';

export const authApi = {
  getCaptcha: () => request.get('/auth/captcha'),
  login: (data) => request.post('/auth/login', data),
  bloggerRegister: (data) => request.post('/auth/blogger-register', data)
};

export const bloggerApi = {
  getProfile: () => request.get('/blogger/profile'),
  updateProfile: (data) => request.put('/blogger/profile', data)
};

export const resourceApi = {
  getById: (id) => request.get('/resources/' + id),
  listByBlogger: (bloggerId, params) => request.get('/resources/blogger/' + bloggerId, { params }),
  create: (data) => request.post('/resources', data),
  update: (id, data) => request.put('/resources/' + id, data),
  remove: (id) => request.delete('/resources/' + id),
  relist: (id) => request.put('/resources/' + id + '/relist')
};

export const uploadApi = {
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return request.post('/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  }
};

export const orderApi = {
  getTransactions: (params) => request.get('/orders/transactions', { params })
};

export const withdrawApi = {
  apply: (data) => request.post('/withdraw/apply', data),
  getMy: (params) => request.get('/withdraw/my', { params })
};
